import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearDayWiseReportDetails,
  clearDayWiseReportList,
  setDayWiseReport,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Button } from "@progress/kendo-react-buttons";
import {
  calculateTotalRow,
  checkAcessRights,
  formatIndianNumber,
  getUnitTypes,
} from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import { clearItemList } from "../../Item/itemSlice";
import { getAllDayWiseReportReport } from "../services/reports.services";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import FormDatePicker from "../../../components/formFields/FormDateField";
import { findAllActiveItemGroup } from "../../ItemGroup/services/itemgroup.services";
import FormMultiSelectionFiled from "../../../components/formFields/FormMultiSelectionFiled";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { getAllActiveCities } from "../../city/services/city.services";
import { ICity } from "../../city/cityModel";
import { findAllAreaAssignDistributor } from "../../areaAssignToDistributor/services/areaAssignToDistributor.services";
import { sumBy } from "lodash";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const ChangeWatcher = ({ formRenderProps }: FormChangeWatcherProps) => {
  const orderby_type = formRenderProps.valueGetter("orderby_type");
  useEffect(() => {
    formRenderProps.onChange("orderby_type", { value: "city" });
  }, []);
  useEffect(() => {
    formRenderProps.onChange("orderby", { value: null });
  }, [orderby_type]);
  return null;
};

const DayWiseReportForm: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);

  const DayWiseReportDetails = useAppSelector(
    (state) => state.reports.DayWiseReportDetails
  );
  const DayWiseReportList = useAppSelector(
    (state) => state.reports.DayWiseReportList
  );

  const ItemGroupList = useAppSelector(
    (state) => state.itemgroup.ItemGroupList
  )?.filter((item: any) => item.isdisplaysalesorder);
  const DistributorList = useAppSelector(
    (state) => state.areaAssign.DistributorList
  );
  const CityList = useAppSelector((state) => state.city.CityList);

  //   const currentPage = useAppSelector((state) => state.pagination.currentPage);
  //   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    dispatch(findAllActiveItemGroup());
    dispatch(getAllActiveCities());
    dispatch(findAllAreaAssignDistributor());
    return () => {
      dispatch(clearDayWiseReportDetails());
      dispatch(clearDayWiseReportList());
      //   dispatch(setCurrentPage(0));
      dispatch(clearItemList());
    };
  }, []);

  const handleSubmit = (values: any) => {
    const payload = {
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : "",
      isdistributor: values.orderby_type === "distributor",
      item_group_id: values?.item_group_id
        ? values?.item_group_id?.join(",")
        : "",
      orderby: values?.orderby ? +values?.orderby : "",
      //   limit: +pageLimit,
      //   skip: +currentPage * +pageLimit,
    };
    dispatch(getAllDayWiseReportReport(payload));
    dispatch(
      setDayWiseReport({ ...payload, orderby_type: values?.orderby_type })
    );
  };

  const ORDER_BY_LIST = [
    { value: "city", label: "City" },
    { value: "distributor", label: "Distributor" },
  ];
  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={DayWiseReportDetails}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <ChangeWatcher formRenderProps={formRenderProps} />
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Day Wise Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="from_date"
                      label="From Date"
                      format={"dd/MM/yyyy"}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="to_date"
                      label="To Date"
                      format={"dd/MM/yyyy"}
                      minDate={
                        formRenderProps.valueGetter("from_date") ||
                        new Date(1900, 1, 1)
                      }
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="item_group_id"
                      label="Item Group"
                      placeholder="Select Item Group"
                      component={FormMultiSelectionFiled}
                      options={ItemGroupList.map((itemgroup: any) => ({
                        value: itemgroup.id,
                        label: itemgroup.item_group,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem></GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="orderby_type"
                      label="Orderby"
                      placeholder="Select Orderby"
                      component={FormSelectionField}
                      astrike={true}
                      validator={requiredValidator}
                      options={ORDER_BY_LIST.map((oderby: any) => ({
                        value: oderby.value,
                        label: oderby.label,
                        // label: `${emp?.first_name} ${emp?.middle_name} ${emp?.last_name}`,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    {formRenderProps.valueGetter("orderby_type") === "city" && (
                      <Field
                        name="orderby"
                        label="City"
                        placeholder="Select City"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={CityList.map((city: ICity) => ({
                          value: city.id,
                          label: city.city_name,
                          // label: `${emp?.first_name} ${emp?.middle_name} ${emp?.last_name}`,
                        }))}
                      />
                    )}
                    {formRenderProps.valueGetter("orderby_type") ===
                      "distributor" && (
                      <Field
                        name="orderby"
                        label="Distributor"
                        placeholder="Select Distributor"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={DistributorList.map((dis: any) => ({
                          value: dis.id,
                          label: dis.account_name,
                          // label: `${emp?.first_name} ${emp?.middle_name} ${emp?.last_name}`,
                        }))}
                      />
                    )}
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <div style={{ marginTop: "35px", textAlign: "end" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
        {loading ? (
          <LoadingPanel gridRef={gridRef} />
        ) : (
          DayWiseReportList &&
          DayWiseReportList.length > 0 && (
            <ShadowCard style={{ marginTop: 10, minHeight: "30vh" }}>
              <DayExportTable />
            </ShadowCard>
          )
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

const DayExportTable: React.FC = () => {
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );

  const DayWiseReportList = useAppSelector(
    (state) => state.reports.DayWiseReportList
  );
  const DayWiseReportDetails = useAppSelector(
    (state) => state.reports.DayWiseReportDetails
  );

  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  const handlePrint = (props: any, type: string) => {
    const state = {
      from_date: props.from_date,
      to_date: props.to_date,
      isdistributor: props?.isdistributor,
      orderby: props.orderby,
      item_group_id: props?.item_group_id,
      initialValues: props.initialValues,
    };

    if (type === "datwisereport") {
      sessionStorage.setItem("dayreportState", JSON.stringify(state));
      const reportTab = window.open("/daywisereportprint", "_blank");
      const interval = setInterval(() => {
        if (reportTab?.closed) {
          sessionStorage.removeItem("dayreportState");
          clearInterval(interval);
        }
      }, 1000);
    }
  };

   const handleExportExcel = () => {
      /*===*===* YOUR TABLE *===*===*/
      const table = document.querySelector(
        ".employee-details-report-table"
      ) as HTMLTableElement;
      if (!table) return;
      const workbook = new ExcelJS.Workbook();
      /*===*===* YOUR SHEET NAME *===*===*/
      const worksheet = workbook.addWorksheet(
        `Sheet1`
      );
      const rows = Array.from(table.querySelectorAll("tr"));
      let excelRowIndex = 1; // Excel row index (1-based)
      const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
      const colWidths: number[] = [];
  
      rows.forEach((row, rowIndex) => {
        const cells = Array.from(row.children) as HTMLTableCellElement[];
        let colIndex = 1; // Reset to first column for each row
  
        cells.forEach((cell) => {
          const cellContent = cell.textContent?.trim() || "";
          const cellLength = cellContent.length;
          const colSpan = cell.colSpan || 1;
          const rowSpan = cell.rowSpan || 1;
  
          colWidths[colIndex] = Math.max(
            colWidths[colIndex] || 10,
            cellLength + 2
          );
          /*===*===* Find the next available column (skip occupied columns) *===*===*/
          while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
            colIndex++;
          }
          /*===*===* SET VALUE AND TABLE STYLE *===*===*/
          const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
          const numericValue = Number(cellContent.replace(/,/g, ""));
          if (
            !isNaN(numericValue) &&
            cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
          ) {
            excelCell.value = numericValue; // Store as a real number
          } else {
            excelCell.value = cellContent; // Store as text
          }
          // excelCell.value = cellContent;
          excelCell.alignment = { horizontal: "center", vertical: "middle" };
          excelCell.border = {
            top: { style: "thin", color: { argb: "000000" } },
            bottom: { style: "thin", color: { argb: "000000" } },
            left: { style: "thin", color: { argb: "000000" } },
            right: { style: "thin", color: { argb: "000000" } },
          };
  
          /*===*===* HEADER STYLE *===*===*/
          if (rowIndex === 0 || rowIndex === 1) {
            excelCell.font = { bold: true };
            excelCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "ffabab" },
            };
          }
          /*===*===* LAST ROW STYLE *===*===*/
          if (rowIndex === rows.length - 1) {
            excelCell.font = { bold: true };
            excelCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "D9E1F2" },
            };
          }
          /*===*===* HANDEL colSpan AND rowSpan *===*===*/
          if (colSpan > 1 || rowSpan > 1) {
            const startCell = worksheet
              .getRow(excelRowIndex)
              .getCell(colIndex).address;
            const endCell = worksheet
              .getRow(excelRowIndex + rowSpan - 1)
              .getCell(colIndex + colSpan - 1).address;
            worksheet.mergeCells(`${startCell}:${endCell}`);
            // Mark merged cells as occupied
            for (let r = 0; r < rowSpan; r++) {
              for (let c = 0; c < colSpan; c++) {
                occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
              }
            }
          }
          colIndex += colSpan;
        });
  
        excelRowIndex++; // Move to next row
      });
  
      worksheet.columns = colWidths.map((width) => ({ width }));
      /*===*===* SAVE THE FILE  *===*===*/
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(
          blob,
          `Day Wise Report-${moment().format("DD-MM-YYYY_hh-mm-A")}.xlsx`
        );
      });
    };

  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const initialValues = {
    filter_columns: [
      "date",
      "item_group",
      "sr_name",
      "distributor_name",
      "area_name",
      "city_name",
      "total_kg_qty",
      "total_pkt_qty",
      "total_bdh_qty",
      "ground_total",
    ],
  };

  const columns = [
    { label: "Distributor Name", value: "distributor_name" },
    { label: "Sales Representative Name", value: "sr_name" },
    { label: "City", value: "city_name" },
    { label: "Area", value: "area_name" },
    { label: "Item Group", value: "item_group" },
    { label: "Total KG", value: "total_kg_qty" },
    { label: "Total PACKET", value: "total_pkt_qty" },
    { label: "Total BANDHA", value: "total_bdh_qty" },
    { label: "Grand Total", value: "ground_total" },
  ];
  const totalItemGroups = Array.from(
    new Set(
      DayWiseReportList.flatMap((entry: any) =>
        entry.item_groups.map((group: any) => group.item_group)
      )
    )
  );
  const unitArray = getUnitTypes(DayWiseReportList);
  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };
  // GET TOTAL ROW
  const totalRow = calculateTotalRow(
    totalItemGroups,
    DayWiseReportList,
    unitArray
  );

  return (
    <>
      {DayWiseReportList && DayWiseReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      Day Wise Report
                      <>
                        <p style={{ fontSize: 16 }}>
                          For Period :-
                          {DayWiseReportDetails.from_date &&
                            DayWiseReportDetails.to_date &&
                            `( ${moment(
                              DayWiseReportDetails.from_date,
                              "YYYY-MM-DD"
                            ).format("DD/MM/YYYY")} - ${moment(
                              DayWiseReportDetails.to_date,
                              "YYYY-MM-DD"
                            ).format("DD/MM/YYYY")} )`}
                        </p>
                      </>
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      {isPrintAccess && (
                        <Button
                          style={{ marginRight: 5 }}
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={() =>
                            handlePrint(
                              {
                                ...DayWiseReportDetails,
                                initialValues: {
                                  filter_columns:
                                    formRenderProps.valueGetter(
                                      "filter_columns"
                                    ),
                                },
                              },
                              "datwisereport"
                            )
                          }
                        >
                          Print
                        </Button>
                      )}
                      {isExcelAccess && (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          onClick={handleExportExcel}
                          style={{ marginRight: 10 }}
                        >
                          Excel Export
                        </Button>
                      )}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"primary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          Filter
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 1,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 340px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  employee-details-report-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                            position: "sticky",
                            top: 0,
                          }}
                        >
                          <>
                            <th style={{ minWidth: 50 }} rowSpan={2}>
                              SR. No
                            </th>
                          </>

                          {checkInclude("date", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 100 }} rowSpan={2}>
                                Date
                              </th>
                            </>
                          )}
                          {checkInclude(
                            "distributor_name",
                            formRenderProps
                          ) && (
                            <>
                              <th style={{ minWidth: 180 }} rowSpan={2}>
                                Distributor Name
                              </th>
                            </>
                          )}
                          {checkInclude("sr_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 200 }} rowSpan={2}>
                                Sales Representative Name
                              </th>
                            </>
                          )}
                          {checkInclude("city_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }} rowSpan={2}>
                                City
                              </th>
                            </>
                          )}
                          {checkInclude("area_name", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 200 }} rowSpan={2}>
                                Area Name
                              </th>
                            </>
                          )}
                          {checkInclude("item_group", formRenderProps) &&
                            unitArray?.map((item_group: any, index: any) => (
                              <th
                                key={index}
                                colSpan={2 * item_group.unitTypes?.length + 1}
                              >
                                {item_group.item_group?.toUpperCase()} GROUP
                              </th>
                            ))}
                          {checkInclude("total_kg_qty", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }} rowSpan={2}>
                                Total KG
                              </th>
                            </>
                          )}
                          {checkInclude("total_pkt_qty", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }} rowSpan={2}>
                                Total PACKET
                              </th>
                            </>
                          )}
                          {checkInclude("total_bdh_qty", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }} rowSpan={2}>
                                Total BANDHA
                              </th>
                            </>
                          )}
                          {checkInclude("ground_total", formRenderProps) && (
                            <>
                              <th style={{ minWidth: 150 }} rowSpan={2}>
                                Grand Total
                              </th>
                            </>
                          )}
                        </tr>

                        <tr
                          className="text-center fw-600"
                          style={{ fontSize: 12, position: "sticky", top: 39 }}
                        >
                          {/* Dynamically Generate Unit and Value Headers */}
                          {checkInclude("item_group", formRenderProps) &&
                            unitArray.map((group, groupIndex) => (
                              <React.Fragment key={groupIndex}>
                                {group?.unitTypes?.map(
                                  (unit: string, unitIdx: number) => (
                                    <React.Fragment key={unitIdx}>
                                      <th style={{ minWidth: 100 }}>{unit}</th>
                                      <th style={{ minWidth: 100 }}>Value</th>
                                    </React.Fragment>
                                  )
                                )}
                                <th style={{ minWidth: 100 }}>Total</th>
                              </React.Fragment>
                            ))}
                        </tr>
                      </thead>

                      {/* Table Body */}

                      <tbody>
                        {DayWiseReportList.map(
                          (item: any, rowIndex: number) => (
                            <tr key={rowIndex}>
                              <td>{rowIndex + 1}</td>
                              {checkInclude("date", formRenderProps) && (
                                <td>
                                  {item.date
                                    ? moment(item.date, "DD/MM/YYYY").format(
                                        "DD-MMM-YYYY"
                                      )
                                    : ""}
                                </td>
                              )}
                              {checkInclude(
                                "distributor_name",
                                formRenderProps
                              ) && <td>{item.distributor_name}</td>}
                              {checkInclude("sr_name", formRenderProps) && (
                                <td>{item.sr_name}</td>
                              )}
                              {checkInclude("city_name", formRenderProps) && (
                                <td>{item.city_name}</td>
                              )}
                              {checkInclude("area_name", formRenderProps) && (
                                <td>{item.area_name}</td>
                              )}
                              {checkInclude("item_group", formRenderProps) &&
                                totalItemGroups.map((_, index) => {
                                  const groupData = item?.item_groups
                                    ?.filter(
                                      (item: any) => item?.item_data?.length > 0
                                    )
                                    ?.find(
                                      (group: any) =>
                                        group.item_group ===
                                        totalItemGroups[index]
                                    );
                                  const units =
                                    unitArray[index].unitTypes || [];

                                  return (
                                    <React.Fragment key={index}>
                                      {units.map((unit: string) => {
                                        const qtyKey =
                                          unit === "KG"
                                            ? "unit_kg_qty"
                                            : unit === "PACKET"
                                            ? "unit_pkt_qty"
                                            : "unit_bdh_qty";
                                        const amtKey =
                                          unit === "KG"
                                            ? "unit_kg_amt"
                                            : unit === "PACKET"
                                            ? "unit_pkt_amt"
                                            : "unit_bdh_amt";

                                        return (
                                          <React.Fragment key={unit}>
                                            <td style={{ textAlign: "end" }}>
                                              {groupData?.item_data[0][qtyKey]
                                                ? groupData?.item_data[0]?.[
                                                    qtyKey
                                                  ]?.toFixed(2)
                                                : 0}
                                            </td>
                                            <td style={{ textAlign: "end" }}>
                                              {groupData?.item_data[0][amtKey]
                                                ? groupData?.item_data[0]?.[
                                                    amtKey
                                                  ]?.toFixed(2)
                                                : 0}
                                            </td>
                                          </React.Fragment>
                                        );
                                      })}

                                      <td style={{ textAlign: "end" }}>
                                        {units
                                          .reduce(
                                            (total: number, unit: string) => {
                                              const amtKey =
                                                unit === "KG"
                                                  ? "unit_kg_amt"
                                                  : unit === "PACKET"
                                                  ? "unit_pkt_amt"
                                                  : "unit_bdh_amt";
                                              return (
                                                total +
                                                (groupData?.item_data[0]?.[
                                                  amtKey
                                                ] || 0)
                                              );
                                            },
                                            0
                                          )
                                          .toFixed(2)}
                                      </td>
                                    </React.Fragment>
                                  );
                                })}
                              {checkInclude(
                                "total_kg_qty",
                                formRenderProps
                              ) && (
                                <td className="text-end">
                                  {item.total_kg_qty?.toFixed(2)}
                                </td>
                              )}
                              {checkInclude(
                                "total_pkt_qty",
                                formRenderProps
                              ) && (
                                <td className="text-end">
                                  {item.total_pkt_qty?.toFixed(2)}
                                </td>
                              )}
                              {checkInclude(
                                "total_bdh_qty",
                                formRenderProps
                              ) && (
                                <td className="text-end">
                                  {item.total_bdh_qty?.toFixed(2)}
                                </td>
                              )}
                              {checkInclude(
                                "ground_total",
                                formRenderProps
                              ) && (
                                <td className="text-end">
                                  {formatIndianNumber(item.ground_total)}
                                </td>
                              )}
                            </tr>
                          )
                        )}

                        {/* Total Row */}
                        <tr style={{ fontWeight: "bold" }}>
                          <td colSpan={2} style={{ fontWeight: "bold" }}>
                            Final Total
                          </td>
                          {checkInclude(
                            "distributor_name",
                            formRenderProps
                          ) && <td style={{ fontWeight: "bold" }}></td>}
                          {checkInclude("sr_name", formRenderProps) && (
                            <td style={{ fontWeight: "bold" }}></td>
                          )}
                          {checkInclude("city_name", formRenderProps) && (
                            <td style={{ fontWeight: "bold" }}></td>
                          )}
                          {checkInclude("area_name", formRenderProps) && (
                            <td style={{ fontWeight: "bold" }}></td>
                          )}

                          {checkInclude("item_group", formRenderProps) &&
                            totalItemGroups.map((item, index) => {
                              const groupTotal = totalRow.item_group[index];

                              return (
                                <React.Fragment key={index}>
                                  {unitArray[index].unitTypes.map(
                                    (unit: string, unitindex: number) => (
                                      <React.Fragment key={unitindex}>
                                        <td
                                          key={`${unit}-total-${unitindex + 1}`}
                                          style={{ textAlign: "end" }}
                                        >
                                          {groupTotal.qty[unit]?.toFixed(2)}{" "}
                                        </td>
                                        <td
                                          key={`${unit}-total-${unitindex + 2}`}
                                          style={{ textAlign: "end" }}
                                        >
                                          {groupTotal.amt[unit]?.toFixed(2)}
                                        </td>
                                      </React.Fragment>
                                    )
                                  )}
                                  <td style={{ textAlign: "end" }}>
                                    {(
                                      groupTotal.amt.KG +
                                      groupTotal.amt.PACKET +
                                      groupTotal.amt.BANDHA
                                    )?.toFixed(2)}
                                  </td>
                                </React.Fragment>
                              );
                            })}
                          {checkInclude("total_kg_qty", formRenderProps) && (
                            <td
                              style={{ fontWeight: "bold" }}
                              className="text-end"
                            >
                              {sumBy(
                                DayWiseReportList,
                                "total_kg_qty"
                              )?.toFixed(2)}
                            </td>
                          )}
                          {checkInclude("total_pkt_qty", formRenderProps) && (
                            <td
                              style={{ fontWeight: "bold" }}
                              className="text-end"
                            >
                              {sumBy(
                                DayWiseReportList,
                                "total_pkt_qty"
                              )?.toFixed(2)}
                            </td>
                          )}
                          {checkInclude("total_bdh_qty", formRenderProps) && (
                            <td
                              style={{ fontWeight: "bold" }}
                              className="text-end"
                            >
                              {sumBy(
                                DayWiseReportList,
                                "total_bdh_qty"
                              )?.toFixed(2)}
                            </td>
                          )}
                          {checkInclude("ground_total", formRenderProps) && (
                            <td
                              style={{ fontWeight: "bold" }}
                              className="text-end"
                            >
                              {formatIndianNumber(
                                sumBy(DayWiseReportList, "ground_total")
                              )}
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default DayWiseReportForm;
